import { nanoid } from 'nanoid';

import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DIALOG_ACTION_TYPE = createNamedActions('dialog', {
  OPEN_DIALOG: 'OPEN_DIALOG',
  UPDATE_DIALOG_OPTIONS: 'UPDATE_DIALOG_OPTIONS',
  CLOSE_DIALOG: 'CLOSE_DIALOG',
});

export const closeDialogAction = id => ({
  type: DIALOG_ACTION_TYPE.CLOSE_DIALOG,
  payload: { id },
});

export const openDialogAction = options => dispatch => {
  const id = options.id || nanoid();

  dispatch({
    type: DIALOG_ACTION_TYPE.OPEN_DIALOG,
    payload: { ...options, id },
  });

  return id;
};

export const updateDialogOptionsAction = (id, options) => dispatch =>
  dispatch({
    type: DIALOG_ACTION_TYPE.UPDATE_DIALOG_OPTIONS,
    payload: { id, ...options },
  });
